
export default {
  info(...data: any[]) {
    if (process.env.NODE_ENV === 'development') {
      console.log('[hantera]', ...data);
    }
  },
  debug(...data: any[]) {
    if (process.env.NODE_ENV === 'development') {
      console.debug('[hantera]', ...data);
    }
  },
  warn(...data: any[]) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[hantera]', ...data);
    }
  },
  error(...data: any[]) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[hantera]', ...data);
    }
  }
}

